import React from "react";

// Fallback hero banners by section (used when wayback images don't load)
const FALLBACKS = {
  default:
    "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=1400&q=70",
  drShannon:
    "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?auto=format&fit=crop&w=1400&q=70",
  medicine:
    "https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?auto=format&fit=crop&w=1400&q=70",
  services:
    "https://images.unsplash.com/photo-1499728603263-13726abce5fd?auto=format&fit=crop&w=1400&q=70",
  clinic:
    "https://images.unsplash.com/photo-1505672984371-f25dcf94b9f5?auto=format&fit=crop&w=1400&q=70",
  resources:
    "https://images.unsplash.com/photo-1466637574441-749b8f19452f?auto=format&fit=crop&w=1400&q=70",
  contact:
    "https://images.unsplash.com/photo-1505765050516-f72dcac9c60a?auto=format&fit=crop&w=1400&q=70",
};

export default function PageBanner({ src, alt = "", fallbackKey = "default" }) {
  return (
    <div className="nn-banner-frame h-[220px] md:h-[260px] mb-6">
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        onError={(e) => {
          if (e.currentTarget.dataset.fb !== "1") {
            e.currentTarget.dataset.fb = "1";
            e.currentTarget.src = FALLBACKS[fallbackKey] || FALLBACKS.default;
          }
        }}
      />
    </div>
  );
}
